import { render, staticRenderFns } from "./ConfigTaxDocument.vue?vue&type=template&id=27176b4e&"
import script from "./ConfigTaxDocument.vue?vue&type=script&lang=js&"
export * from "./ConfigTaxDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports